import { RED_LIGHT_FINE } from '../../content/junctions';
import type { EventBus } from '../../core/events';
import type { RunState } from '../../game/RunState';
import { junctionAt, signalAt } from './signals';

const ANNOUNCE_WITHIN = 110;

/** Warns about the light ahead and fines the driver for crossing the stop line on red. */
export function updateRedLight(state: RunState, events: EventBus): void {
  const point = junctionAt(state.junction.seq);
  const signal = signalAt(point.seq, state.stats.seconds);
  const front = state.bus.s + state.bus.size.length / 2;
  const toLine = point.stopLine - front;
  if (!state.junction.announced && toLine < ANNOUNCE_WITHIN && toLine > 0) {
    state.junction.announced = true;
    events.emit('junction:approaching', { name: point.junction.name, signal });
  }
  if (!state.junction.crossedStopLine && toLine <= 0) {
    state.junction.crossedStopLine = true;
    if (signal !== 'red') state.stats.cleanJunctions += 1;
    if (signal === 'red') {
      state.stats.redLightsRun += 1;
      state.stats.finesPesewas += RED_LIGHT_FINE;
      events.emit('junction:ranRed', { name: point.junction.name, finePesewas: RED_LIGHT_FINE });
    }
  }
}
